import React ,{  useState, useEffect }  from 'react'
import { Link } from 'react-router-dom';
//import './HomeInfo.css'


const HomeInfo = () => {


  const [showConsent, setShowConsent] = useState(false);
  
  useEffect(() => {
   
    const consent = localStorage.getItem('gdprConsent');

    if (!consent) {

      setShowConsent(true);  // Show consent banner if consent is not yet given
    }

  }, []); // Empty dependency array means this effect runs once when the component mounts

  const handleAccept = () => {
    localStorage.setItem('gdprConsent', 'accepted');  // Store consent
    setShowConsent(false);  // Hide banner
  };

  const bannerStyle = {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    backgroundColor: '#333',
    color: '#fff',
    padding: '10px',
    textAlign: 'center',
    zIndex: 1000,
  };
  
  const buttonStyle = {
    backgroundColor: '#4CAF50',
    color: 'white',
    border: 'none',
    padding: '2px 4px',
    cursor: 'pointer',
    marginLeft: '5px',
  };


  return (

    <>
    
    <h3>Home</h3>
   <Link to="/register">
          <button className='secondary-button' style={{ margin: '3px' }}>Register Now</button>
    </Link>
    <br/>
    <Link to="/login">
          <button className='secondary-button' style={{ margin: '3px' }}>Check My Points</button>
    </Link>
   
  {showConsent ? (
  <div className="bannerStyle">
    <p>This website uses cookies to ensure you get the best experience. By continuing, you accept our cookie policy.</p>
    <p style={{ fontSize: '1.7em' }}> <a onClick={handleAccept} class="styled-link">Accept</a></p>
    <p><a href="https://siamthai.ie/terms-and-conditions/" target="_blank" rel="noopener noreferrer" class="styled-link">
  Terms and Conditions
</a> | <a href="https://siamthai.ie/privacy-policy/" target="_blank" rel="noopener noreferrer" class="styled-link">
Privacy Policy
</a></p>
   
  </div>
) : null}
    </>
    
  )
}

export default HomeInfo